import script from "./Activity_InfoVer2.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_InfoVer2.vue?vue&type=script&setup=true&lang=js"

import "./Activity_InfoVer2.vue?vue&type=style&index=0&id=55d55495&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d55495"]])

export default __exports__